import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {ServerDataContext} from "./ServerDataContext";

export interface FullstackTokenizer {
    submit: () => void;
}

export interface FullstackTokenizerResponse {
    status: 'success' | 'error' | 'validation';
    token?: string;
    msg?: string;
    invalid?: string[];
}

export interface FullstackValidResponse {
    isValid: boolean
}

export interface FullstackTokenizerSettings {
    url?: string;
    apikey: string;
    container: string;
    submission: (response: FullstackTokenizerResponse) => void;
    validCard: (response: FullstackValidResponse) => void;
    settings: {
        payment?: {
            types: string[];
            card?: {
                requireCVV?: boolean;
                billing_required?: {
                    zip?: boolean
                }
            },
            ach?: {
                billing_required?: {
                    zip?: boolean
                }
            },
        },
        styles?: {}
    }
}

interface FullstackContextState {
}

export const FullstackContext = React.createContext({} as FullstackContextState);

export const FullstackProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    useEffect(() => {
        if (data.company && data.company.is_fullstack_enabled) {
            const fullstackScriptElement = document.createElement('script');
            fullstackScriptElement.async = true;
            fullstackScriptElement.src = data.company.fullstack_tokenizer_script_url;
            document.body.appendChild(fullstackScriptElement);
        }
    }, [data.company]);

    return (
        <FullstackContext.Provider value={{}}>
            {children}
        </FullstackContext.Provider>
    )
}